
































import { Component, Prop, Vue, Ref } from 'vue-property-decorator'
import { Image } from '@/types'

@Component
export default class Frame extends Vue {
  @Prop() private image!: Image
  @Prop({ default: false }) private isAboveFold!: boolean
  @Ref() private frameContainer!: HTMLDivElement

  private isVisible: boolean = false
  private imageLoaded: boolean = false
  private preloaded: boolean = false
  private observer: IntersectionObserver | null = null

  created() {
    // 首屏图不等 IntersectionObserver，否则 LCP 要多等一轮回调
    this.isVisible = this.isAboveFold
  }

  mounted() {
    if (this.isVisible) {
      return
    }
    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true
            if (this.observer) {
              this.observer.disconnect()
            }
          }
        })
      },
      { threshold: 0.1 },
    )
    this.observer.observe(this.frameContainer)
  }

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  onImageLoad() {
    this.imageLoaded = true
  }

  preloadFullImage() {
    if (this.preloaded) return
    const img = new Image()
    img.src = this.image.url
    if (this.image.webpUrl) {
      const webpImg = new Image()
      webpImg.src = this.image.webpUrl
    }
    this.preloaded = true
  }
}
